<template>
	<div id="qualManage">
		<div class="title-top bg-f topDiv">
			品牌资质设置
			<div class="batchDiv">
          <el-link class="link"  type="primary" :underline="false" @click="dialogOperation=true">运营负责人</el-link>
      </div>
		</div>
		<div class="main pl-100 pl-20 pr-20 pt-50 pb-50 mt-5 bg-f">
			<el-form :inline="true" :model="form" label-width="auto">
					<el-form-item label="客户名称">
						<el-input v-model.trim="form.storeName"></el-input>
					</el-form-item>
					<el-form-item label="客户K3编码">
						<el-input v-model.trim="form.k3No"></el-input>
					</el-form-item>
					<el-form-item label="所属区域">
						<districtSelect v-model.trim="form.districtId"></districtSelect>
					</el-form-item>
					<el-form-item label="是否签约客户">
						<el-select v-model="form.enableSign" clearable placeholder="请选择">
							<el-option label="是" :value="true"></el-option>
							<el-option label="否" :value="false"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="交易状态">
						<el-select v-model="form.enableOverdueOrder" clearable placeholder="请选择">
							<el-option label="启用" :value="true"></el-option>
							<el-option label="禁用" :value="false"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="info" @click='search' icon="el-icon-search">搜 索</el-button>
					</el-form-item>
			</el-form>

			<div>
				<el-table :data="list" border style="width: 100%">
          <el-table-column prop="" label="客户名称">
            <template slot-scope="{row}">
              <div>
                <div>{{row.storeName}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="K3编码">
            <template slot-scope="{row}">
              <div>
                <div>{{ row.k3No }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="客户帐号">
            <template slot-scope="{row}">
              <div>
                <div>{{row.loginName}}</div>
              </div>
            </template>
          </el-table-column>
					<el-table-column prop="districtName" label="所属区域"></el-table-column>
  				<el-table-column label="联系人/电话">
						<template slot-scope="{row}">
							<p>联系人:{{ row.linkname }}</p>
							<p>电话:{{ row.tel }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="关联业务员"></el-table-column>
					<el-table-column prop="defaultDepartmentLeaderName" label="战区负责人"></el-table-column>
					<el-table-column prop="opEmployeeName" label="运营负责人"></el-table-column>
					<el-table-column prop="gmtSignStart" label="品牌开始时间">
						<template slot-scope="{row}">
							<span v-if="row.gmtSignStart">{{row.gmtSignStart | timenData}}</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column prop="gmtSignEnd" label="品牌结束时间">
						<template slot-scope="{row}">
							<span v-if="row.gmtSignEnd">{{row.gmtSignEnd | timenData}}</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column prop="enableSign" label="是否签约客户">
						<template slot-scope="{row}">
							<span>{{row.enableSign?'是':'否'}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="enableOverdueOrder" label="逾期交易状态">
						<template slot-scope="{row}">
							<span v-if="row.enableOverdueOrder!=null">{{row.enableOverdueOrder?'启用':'禁用'}}</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
          <el-table-column prop="" label="操作" align="center">
            <template slot-scope="{row}">
              <div style="padding:5px 0">
								<div style="margin:5px 0" v-if="row.enableSign">
									<el-link class="link" v-if="row.enableOverdueOrder"  type="danger" :underline="false"  @click="changeStatus(row.id,false)">禁用</el-link>
									<el-link class="link" v-else  type="success" :underline="false" @click="changeStatus(row.id,true)">启用</el-link>
								</div>
								<div style="margin:5px 0">
									<el-link class="link"  type="primary" :underline="false" @click="edit(row)">编辑</el-link>
								</div>
								<div style="margin:5px 0">
                	<el-link class="link" :underline="false" @click="opendialogLog(row)">修改记录</el-link> 
								</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
				<el-pagination
						v-if="total > 0"
						class="tar mt-20"
						:current-page="form.pageIndex"
						:page-size="form.pageSize"
						:total="total"
						layout="prev , pager, next, jumper"
						@current-change="currentChange"
					>
						<!-- 分页组件 -->
					</el-pagination>
			</div>
		</div>
		<!-- 运营负责人弹框 -->
		<el-dialog title="运营负责人" :visible.sync="dialogOperation">
			<el-form :model="operationForm" label-width="150px">
				<el-form-item label="运营负责人">
					<selectEmployeeInfo v-model="operationForm.opEmployeeId"/>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitOperation">确 定</el-button>
				<el-button @click="dialogOperation = false">取 消</el-button>
			</div>
		</el-dialog>
		<!-- 编辑弹框 -->
		<el-dialog title="编辑" :visible.sync="dialogEditVisible" @close="closeEdit">
			<el-form :model="editForm" ref="editForm" :rules="rules" label-width="150px">
				<el-form-item label="客户名称">
					{{editForm.storeName}}
				</el-form-item>
				<el-form-item label="客户编码" >
					{{editForm.k3No}}
				</el-form-item>
				<el-form-item label="是否签约客户" prop="enableSign">
					<el-select v-model="editForm.enableSign" placeholder="请选择">
						<el-option label="是" :value="true"></el-option>
						<el-option label="否" :value="false"></el-option>
					</el-select>
				</el-form-item>
				<div v-if="editForm.enableSign">
					<el-form-item label="品牌开始时间" prop="gmtSignStart">
						<el-date-picker
							v-model="editForm.gmtSignStart"
							type="date"
							value-format="timestamp"
							placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="品牌结束时间" prop="gmtSignEnd">
						<el-date-picker
							v-model="editForm.gmtSignEnd"
							type="date"
							value-format="timestamp"
							placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitEdit">确 定</el-button>

				<el-button @click="dialogEditVisible = false">取 消</el-button>
			</div>
		</el-dialog>
		<!-- 修改记录弹框 -->
		<el-dialog title="修改记录" :visible.sync="dialogLogVisible" width="700px">
			<div style="padding:0 10px">
				<el-form :model="logForm" label-width="150px">
					<el-form-item label="客户名称">
						{{logForm.storeName}}
					</el-form-item>
					<el-form-item label="客户编码" >
						{{logForm.k3No}}
					</el-form-item>
					<el-form-item label="修改记录">
						<el-table
							:data="logList"
							style="width: 100%">
							<el-table-column
								prop="gmtSignStart"
								label="品牌开始时间"
								>
							<template slot-scope="{row}">
								<span v-if="row.gmtSignStart">{{row.gmtSignStart | timenData}}</span>
								<span v-else>--</span>
							</template>
							</el-table-column>
							<el-table-column
								prop="gmtSignEnd"
								label="品牌结束时间"
								>
								<template slot-scope="{row}">
									<span v-if="row.gmtSignEnd">{{row.gmtSignEnd | timenData}}</span>
									<span v-else>--</span>
								</template>
							</el-table-column>
							<el-table-column
								prop="operatorName"
								label="操作人"
								>
								
							</el-table-column>
							<el-table-column
								label="修改时间"
								>
								<template slot-scope="{row}">
									<span v-if="row.gmtModified">{{row.gmtModified | timenData}}</span>
									<span v-else>--</span>
								</template>
							</el-table-column>
						</el-table>
					</el-form-item>
				</el-form>
			</div>
			
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogLogVisible = false">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { axiosApi, basePath } from "~/api/api";
	import { getClientAllList } from "~/api/publicInfo";
	import { updateOperations, enableInfo, disableInfo, logInfo, signTimeUpdate } from "~/api/qualManage";
	import districtSelect from "@/components/districtSelect/districtSelect.vue";
	import selectEmployeeInfo from "@/components/employee/selectEmployeeInfo.vue";
	export default {
		components:{
			districtSelect,
			selectEmployeeInfo
		},
		data() {
			return {
				dialogOperation: false,
				dialogEditVisible:false,
				dialogLogVisible:false,
				form:{
					sellerId: sessionStorage.traderId,
					storeName: null,
					k3No:null,
					districtId:null,
					enableSign:null,
					enableOverdueOrder:null,
					ctype:42, // 只显示加盟店
					pageIndex:1,
					pageSize:10,
				},
				list:[],
				total:0,
				operationForm:{},
				editForm:{
					enableSign:null,
					gmtSignStart:null,
					gmtSignEnd:null,
				},
				logForm:{},
				logList:[],
				rules:{
					enableSign:[
						{ required: true, message: '请选是否签约客户', trigger: 'change' }
					],
					gmtSignStart:[
						{ type: 'date', required: true, message: '请选择日期', trigger: 'change' }
					],
					gmtSignEnd:[
						{ type: 'date', required: true, message: '请选择日期', trigger: 'change' }
					],
				}
			}
		},
		methods: {
			search(){
				this.getList()
			},
			submitOperation(){
				updateOperations(this.operationForm).then(res=>{
					this.dialogOperation = false
					this.operationForm = {}
					this.search()
				}).catch(err=>{

				})
			},
			edit(row){
				this.editForm = {
					storeName:row.storeName,
					k3No:row.k3No,
					id:row.id,
					enableSign:row.enableSign,
					gmtSignStart:row.gmtSignStart,
					gmtSignEnd: row.gmtSignEnd
				}
				this.dialogEditVisible = true
			},
			closeEdit(){
				this.$refs['editForm'].resetFields();
				this.dialogEditVisible = false
			},
			submitEdit(){
				 this.$refs['editForm'].validate((valid) => {
						if (valid) {
							signTimeUpdate(this.editForm).then(res=>{
								this.dialogEditVisible = false
								this.editForm = {}
								this.search()
							}).catch(err=>{

							})
						} else {
							console.log('error submit!!');
							return false;
						}
				 })
			},
			opendialogLog(row){
				this.logForm = {
					storeName:row.storeName,
					k3No:row.k3No,
				}
				this.getLogInfo(row.id)
			},
			getLogInfo(id){
				logInfo({buyerSellerRelationId:id}).then(res=>{
					this.logList = res
					this.dialogLogVisible = true
				}).catch(err=>{

				})
			},
			changeStatus(id,type){
				this.$confirm(`此操作将${type?"启用":"禁用"}该品牌资质, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         
					if(type){
						this.setEnableInfo(id)
					}else{
						this.setDisableInfo(id)
					}
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
			},
			setEnableInfo(id){
				enableInfo({id:id}).then(res=>{
					this.$message({
            type: 'success',
            message: '操作成功!'
          });
					this.getList()
				}).catch(err=>{

				})
			},
			setDisableInfo(id){
				disableInfo({id:id}).then(res=>{
					this.$message({
            type: 'success',
            message: '操作成功!'
          });
					this.getList()
				}).catch(err=>{
					
				})
			},

			getList(){
				getClientAllList(this.form).then(res=>{
						this.list = res.elements
						this.total = res.totalCount
				}).catch(err=>{

				})
			},
			// 分页
			currentChange(val){
				this.form.pageIndex = val
				this.getList()
			},
		},
		//进入加载
		mounted() {
			this.getList()
		}
	};
</script>

<style lang="less">
	#qualManage {
		.topDiv{
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-right: 20px;
			box-sizing: border-box;

			.batchDiv{
				display: flex;
				justify-content: flex-end;
				align-items: center;
			}
		}
		.border-bottom {
			border-bottom: 1px dashed #DDDDDD;
		}
		.w750{
			width: 750px;
		}
	}
</style>